import React from 'react'
import Modal from '.'
import ArrowLeftIcon from '../Icons/ArrowLeft'
import ShareIcon from '../Icons/ShareIcon'
import PDFPreview from '../PDFPreview'
import postMessageToRN, {
  SHARE_FILE,
} from '../../utils/helpers/ReactNativeEvents'

const DocumentPreviewModal = ({
  show = false,
  onClose,
  documentName,
  documentLink,
}) => {
  const handleShareClick = () => {
    postMessageToRN(SHARE_FILE, {
      documentName,
      documentLink,
    })
  }

  return (
    <Modal
      isOpen={show}
      onClose={onClose}
      fullScreen={true}
      showCloseBtn={false}
    >
      <div className="w-full h-screen pt-14">
        <div className="flex items-center justify-between px-4 py-2 fixed top-0 left-0 right-0 bg-white">
          <button
            className="bg-transparent border-none cursor-pointer py-2 pr-2"
            onClick={onClose}
          >
            <ArrowLeftIcon />
          </button>
          <div className="flex-1 text-md font-bold">{documentName}</div>
          <button
            className="bg-transparent border-none cursor-pointer p-2"
            onClick={handleShareClick}
          >
            <ShareIcon color="#555" />
          </button>
        </div>
        <div className="w-full h-full">
          <PDFPreview documentLink={documentLink} />
        </div>
      </div>
    </Modal>
  )
}

export default DocumentPreviewModal
